var selectorStr = '';
var mySwiper, myVideos, mobile;

// Used to compensante Chrome/Safari bug (they don't care about scroll bar for width)
function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}

function resize(){
    // ajuste tamaño videos
    $.each($('.video-js'), function() { 
        $(this).height($(this).width()*(675/1200));
    });

    $('.banner .list-box .libox').height($('.banner .list-box .libox').width());
    $('.banner .list-box .libox').width($('.banner .list-box .libox').width());
    /*if ($(window).width()+scrollCompensate() >= 992) { //version desktop
        $(".banner-boxes").each(function(){
            $(this).children('.banner-caption').height($(this).height()-24);
        });
    } else {
        $(".banner-boxes .banner-caption").height('');
    }
    if ($('#nav-principal .dropleft-menu').hasClass('open')){
        $('#nav-principal .dropleft-menu').removeClass('open');
    }*/
    if (!mobile){
        // Controlar si ha saltado version mobile
        if (Modernizr.touch) {$('#wrapper').width($(window).width());}
        if ($(window).width()+scrollCompensate() < 740) { 
           
            //if (boxSwiper){
                //boxSwiper = false;
                $('.box-groups').isotope('destroy');
                $('.box-videos').isotope('destroy');

                mySwiper = new Swiper('.box-groups', {
                    slidesPerView: 'auto',
                    paginationClickable: false,
                    spaceBetween: 20,
                    observer: true
                });
                myVideos = new Swiper('.box-videos', {
                    slidesPerView: 'auto',
                    paginationClickable: false,
                    spaceBetween: 20,
                    observer: true
                });
                setTimeout(function() {
                    $(document).on("click", '.btn-return', function() {
                        swip = $(this).closest('.swiper-container-horizontal')[0];
                        swip.swiper.slideTo(0);
                    });
                }, 300);
            //}
            mobile = true;
        } else {
            $('#aside-header').width('');
            $('#aside-header .scroll').height($(window).height()-110);
        }
    // Controlar si no mobile version
    } else {
        if ($(window).width()+scrollCompensate() >= 740) {
           
            $('#aside-header').width('');
            $('#aside-header .scroll').height($(window).height()-110);
            $('.nav-top .toggle-menu').css('display', '').parent().removeClass('open');
            //if (!boxSwiper){
                //boxSwiper = true;
                $('.box-groups').each(function(){ this.swiper.destroy(true, true); });
                $('.box-videos').each(function(){ this.swiper.destroy(true, true); });

                $('.box-groups').isotope({
                    itemSelector : '.box',
                    masonry: {
                        columnWidth: 240,
                        gutterWidth: 20
                    }
                });
                $('.box-videos').isotope({
                    itemSelector : '.video',
                    masonry: {
                        columnWidth: 280,
                        gutterWidth: 20
                    }
                });
            //}
            mobile = false;  
        } else {
            $('#aside-header .scroll').height($(window).height());
            //mySwiper.reInit();
           // myVideos.reInit();
        }
    }
}


$(function(){
    $('input').iCheck();
    $("select").selectBoxIt({hideCurrent: true});
    $('a.nota').tooltip();

    var sMenuHeight = $('.content-page').parent().find('.scroll').height()+ 66;
    $('.content-page').css('min-height',sMenuHeight+'px');

    $.each($('.video-js'), function() { 
        $(this).height($(this).width()*(675/1200));
    });

    // modified Isotope methods for gutters in masonry
    $.Isotope.prototype._getMasonryGutterColumns = function() {
        var gutter = this.options.masonry && this.options.masonry.gutterWidth || 0;
        containerWidth = this.element.width();

        this.masonry.columnWidth = this.options.masonry && this.options.masonry.columnWidth ||
        // or use the size of the first item
        this.$filteredAtoms.outerWidth(true) ||
        // if there's no items, use size of container
        containerWidth;

        this.masonry.columnWidth += gutter;

        this.masonry.cols = Math.floor((containerWidth + gutter) / this.masonry.columnWidth);
        this.masonry.cols = Math.max(this.masonry.cols, 1);
    };

    $.Isotope.prototype._masonryReset = function() {
        // layout-specific props
        this.masonry = {};
        // FIXME shouldn't have to call this again
        this._getMasonryGutterColumns();
        var i = this.masonry.cols;
        this.masonry.colYs = [];
        while (i--) {
            this.masonry.colYs.push(0);
        }
    };

    $.Isotope.prototype._masonryResizeChanged = function() {
        var prevSegments = this.masonry.cols;
        // update cols/rows
        this._getMasonryGutterColumns();
        // return if updated cols/rows is not equal to previous
        return (this.masonry.cols !== prevSegments);
    };


    if($('.carouselSwip').length>0){
        var carSwiper = new Swiper('.carouselSwip', {
            pagination: '.swiper-pagination',
            slidesPerView: 2,
            loop:true,
            paginationClickable: true,
            centeredSlides: true,
            spaceBetween: 4,
            setWrapperSize : true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev'
        });
    }
    if($('.box-research-iso').length>0){
        var grids = "";
        grids = $('.box-research-iso').isotope({
            itemSelector : '.box-rc',
            masonry: {
                columnWidth: 260,
                gutterWidth: 20
            }
        });
    }

    if($('.box-researchord').length>0){
        grid = $('.box-researchord').isotope({
            itemSelector : '.box-rc',
            getSortData: {
                nombre : function ( $elem ) {
                  return $elem.find('.nombre').text();
                }
            },
            masonry: {
                columnWidth: 260,
                gutterWidth: 20
            }
        });
        $(document).on("change",".orderBut",function(){
            var orden = $(this).val();
            console.log(orden);
            grid.isotope({ sortBy: orden, sortAscending : true });

        })
        
    }


              
    $('.banner .list-box .libox').height($('.banner .list-box .libox').width());
    $('.banner .list-box .libox').width($('.banner .list-box .libox').width());

   /* if ($(window).width()+scrollCompensate() >= 992) { //version desktop
        $(".banner-boxes").each(function(){
            $(this).children('.banner-caption').height($(this).height()-24);
        });
    } else {
        $(".banner-boxes .banner-caption").height('');
    }*/
    
    $('#aside-header .scroll').jScrollPane({autoReinitialise: true});

    // Controlar si ha saltado version mobile
    if ($(window).width()+scrollCompensate() < 740) { 
        mobile = true;
        $('#aside-header .scroll').height($(window).height());
        mySwiper = new Swiper('.box-groups', {
            slidesPerView: 'auto',
            paginationClickable: false,
            spaceBetween: 20,
            observer: true
        });

        mySwiper = new Swiper('.box-videos', {
            slidesPerView: 'auto',
            paginationClickable: false,
            spaceBetween: 20,
            observer: true
        });
        setTimeout(function() {
            $(document).on("click", '.btn-return', function() {
                swip = $(this).closest('.swiper-container-horizontal')[0];
                swip.swiper.slideTo(0);
            });
        }, 300);
        
    // Controlar si no mobile version
    } else {
        mobile = false;
        $('#aside-header .scroll').height($(window).height()-110);
        $('.box-groups').isotope({
            itemSelector : '.box',
            masonry: {
                columnWidth: 240,
                gutterWidth: 20
            }
        });
        $('.box-videos').isotope({
            itemSelector : '.video',
            masonry: {
                columnWidth: 280,
                gutterWidth: 20
            }
        });    
    }

    jQuery(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
        event.preventDefault();
        var element = jQuery(this);
        var attr = jQuery(element).attr('data-gallery');
        if (typeof attr == typeof undefined){
            return jQuery(this).ekkoLightbox();
        } else {
            
                return jQuery(this).ekkoLightbox({
                    onShow: function() {
                        jQuery('.ekko-lightbox').addClass('gallery');
                    }
                });
            
        }
    });

    jQuery(document).delegate('a[href^="#"]', 'click', function(event) {
        event.preventDefault();
        var element = jQuery(this);
        var attr = jQuery(element).attr('href');
        $('html, body').animate({
              scrollTop: $(attr).offset().top-80
        }, 600);
        
    });
    
    // Comportamient menus
    if (!Modernizr.touch) { 
        var menu = false;
        var submenu = false;
        var subsubmenu = false;
        $("#nav-principal a.dropdown-toggle").mouseenter(function(){
            //if ($(this).parent().children('.dropleft-menu').size() > 0){
                menu = true;
                if ($(window).width()+scrollCompensate() >= 740){
                    if ($(this).hasClass('level0')){
                        if (submenu){
                            $('#nav-principal .dropleft-menu').removeClass('open');
                            $('#nav-principal .dropleft-menu').css('z-index', '');
                            $(this).next('.dropleft-menu').addClass('open').css('z-index','1'); 
                        } else {
                            $(this).next('.dropleft-menu').addClass('open');
                            $('#container').addClass('submenu-open');
                        }
                    } else {
                        if (subsubmenu){
                            $('#nav-principal .dropleft-menu .dropleft-menu').removeClass('open');
                            $('#nav-principal .dropleft-menu .dropleft-menu').css('z-index', '');
                            $(this).next('.dropleft-menu').addClass('open').css('z-index','1'); 
                        } else {
                            $(this).next('.dropleft-menu').addClass('open');
                            $('#container').addClass('subsubmenu-open');
                        }
                    }
                }
            //}
        });

        $("#nav-principal a.dropdown-toggle").mouseleave(function(){
            //menu = false;
            var item = $(this).next('.dropleft-menu');
            if ($(window).width()+scrollCompensate() >= 740){
                if ($(this).hasClass('level0')){
                    setTimeout(function() {
                        if (!submenu){
                            item.removeClass('open');
                            if (!menu){ $('#container').removeClass('submenu-open');}
                        }
                    },200);
                }else {
                    setTimeout(function() {
                        if (!subsubmenu){
                            item.removeClass('open');
                            $('#container').removeClass('subsubmenu-open');
                        }
                    },200);                
                }
            }
        });
        $("#nav-principal").mouseleave(function(){
            var menu = false;
            var submenu = false;
            var subsubmenu = false;
            $('#container').removeClass('submenu-open');
        });
        $('#nav-principal .dropleft-menu.level0').mouseenter(function(){
            submenu = true;
        });        
        $('#nav-principal .level0 .dropleft-menu').mouseenter(function(){
            subsubmenu = true;
        });
        $('#nav-principal .dropleft-menu.level0').mouseleave(function(){
            submenu = false;
            if ($(window).width()+scrollCompensate() >= 740){
                if (!submenu){
                    $('#nav-principal .dropleft-menu').removeClass('open');
                    $('#container').removeClass('submenu-open');
                }
            }
        });                
        $('#nav-principal .level0 .dropleft-menu').mouseleave(function(){
            subsubmenu = false;
            if ($(window).width()+scrollCompensate() >= 740){
                if (!subsubmenu){
                    $('#nav-principal .level0 .dropleft-menu').removeClass('open');
                    $('#container').removeClass('subsubmenu-open');
                }
            }
        });                
        $("#main").mouseenter(function(){ 
            if ($(window).width()+scrollCompensate() >= 740){
                $('#nav-principal .level0 .dropleft-menu').removeClass('open');
                $('#container').removeClass('subsubmenu-open');
                subsubmenu = false;
                setTimeout(function() {
                    $('#nav-principal .dropleft-menu.level0').removeClass('open');
                    $('#container').removeClass('submenu-open');
                    submenu = false;
                    menu = false;
                },400);
            }
        });
        $(document).on("click", "#nav-principal a.dropdown-toggle", function() {
            if ($(window).width()+scrollCompensate() < 740){
                menu = true;
                var item = $(this).next('.dropleft-menu');
                if ($(window).width()+scrollCompensate() >= 740){
                    if (submenu){
                        $('#nav-principal .dropleft-menu').removeClass('open').css('z-index', '');
                        item.addClass('open').css('z-index','1'); 
                    } else {
                        item.addClass('open');
                        $('#container').addClass('submenu-open');
                    }
                } else {
                    var item = $(this).next('.dropleft-menu');
                    if (! $(item).hasClass('open')){
                        $('#nav-principal .dropleft-menu').removeClass('open');
                        $(item).addClass('open');
                    } else {
                        $(item).removeClass('open');
                    }
                }
                submenu = true;
            }
        });        
    } else {

        $('#wrapper').width($(window).width());

        $(document).on("click", "#nav-principal a.dropdown-toggle", function() {
            //if ($(this).parent().children('.dropleft-menu').size() > 0){
                menu = true;
                var item = $(this).next('.dropleft-menu');
                if ($(window).width()+scrollCompensate() >= 740){
                    if (submenu){
                        $('#nav-principal .dropleft-menu').removeClass('open').css('z-index', '');
                        item.addClass('open').css('z-index','1'); 
                    } else {
                        item.addClass('open');
                        $('#container').addClass('submenu-open');
                    }
                } else {
                    var item = $(this).next('.dropleft-menu');
                    if (! $(item).hasClass('open')){
                        $('#nav-principal .dropleft-menu').removeClass('open');
                        $(item).addClass('open');
                    } else {
                        $(item).removeClass('open');
                    }
                }
                submenu = true;
            //}
        });        
    };

    $(document).on("click", "#btn-menu", function() {
        if ($('#aside-header').hasClass('open')){
    		$('#nav-principal .dropleft-menu').removeClass('open');
    		$('#container').removeClass('submenu-open');
    		setTimeout(function() {                    	
    			$('#aside-header').removeClass('open');
    			$('#container').removeClass('menu-open');
    			$('#btn-menu').children('.icon').removeClass().addClass('icon icon-menu');
                menu=false;
                submenu=false;
    		},400);
        }else{
            $(this).children('.icon').removeClass().addClass('icon icon-close');
            $('#aside-header').addClass('open');
            $('#container').addClass('menu-open');
            menu=true;
        };
    }).on('click','.toggle',function(){
        $(this).next('.toggle-menu').slideToggle();
        if ($(this).parent().hasClass('open')){
            $(this).parent().removeClass('open');
        } else {
            $(this).parent().addClass('open');
        }
    }).on('click','#showSearch',function(){
        $('#busquedaForm').fadeIn();
        $('#busq').focus();
    }).on('click','#closeSearch',function(){
        $('#busquedaForm').fadeOut();
    })

});

$(window).load(function() {
   resize();
}); 

$(window).resize(function(){
    resize();
});


